var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "normal" }, [
      _c("div", { staticClass: "give-box" }, [
        _c("h2", [_vm._v("官方选房师分配客户")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "normal" },
          [
            _vm._v("\n        目标楼盘\n        "),
            _c(
              "el-select",
              {
                ref: "agent2Select",
                attrs: {
                  filterable: "",
                  placeholder: "选择楼盘",
                  "default-first-option": "",
                  "remote-method": _vm.searchEstate1,
                  remote: "",
                  clearable: ""
                },
                on: {
                  "hook:mounted": _vm.cancalReadOnly,
                  "visible-change": _vm.cancalReadOnly
                },
                model: {
                  value: _vm.giveFromEstate,
                  callback: function($$v) {
                    _vm.giveFromEstate = $$v
                  },
                  expression: "giveFromEstate"
                }
              },
              _vm._l(_vm.jpEstates, function(item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.real_estate_name, value: item.id }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "normal" },
          [
            _vm._v("\n        限制日期\n        "),
            _c("el-date-picker", {
              attrs: {
                size: "small",
                type: "date",
                "value-format": "yyyy-MM-dd",
                placeholder: "选择日期"
              },
              model: {
                value: _vm.limit_date,
                callback: function($$v) {
                  _vm.limit_date = $$v
                },
                expression: "limit_date"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("默认选取15天内")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "normal" },
          [
            _vm._v("\n        查询数量\n        "),
            _c("el-button", { on: { click: _vm.toCheckCustomer } }, [
              _vm._v("开始查询")
            ])
          ],
          1
        ),
        _vm._v(" "),
        Object.keys(_vm.hasNumMap).length
          ? _c(
              "div",
              _vm._l(_vm.giveKeys, function(giveKey) {
                return _c(
                  "div",
                  {
                    key: giveKey,
                    staticStyle: {
                      display: "flex",
                      gap: "10px",
                      height: "40px",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "70px" } }, [
                      _vm._v(_vm._s(_vm.giveKeyMap[giveKey]))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.giveNumMap[giveKey],
                          expression: "giveNumMap[giveKey]"
                        }
                      ],
                      staticStyle: { height: "20px" },
                      attrs: { placeholder: "分配人数" },
                      domProps: { value: _vm.giveNumMap[giveKey] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.giveNumMap, giveKey, $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("可分配" + _vm._s(_vm.hasNumMap[giveKey]) + "人")
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.estateSales.length
          ? _c("div", { staticClass: "normal" }, [
              _vm._v("\n        选择选房师\n        "),
              _c(
                "div",
                { staticClass: "sale-box" },
                _vm._l(_vm.estateSales, function(sale) {
                  return _c(
                    "div",
                    {
                      key: sale.erp_uid,
                      class: {
                        "current-sale": _vm.chooseSaleId === sale.erp_uid
                      },
                      on: {
                        click: function($event) {
                          _vm.chooseSaleId = sale.erp_uid
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(sale.saleInfo.user_name) +
                          "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "normal" },
          [
            _vm._v("\n        分配客户\n        "),
            _c("el-button", { on: { click: _vm.toGiveCustomer } }, [
              _vm._v("开始分配")
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15942346", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15942346","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/giveCustomers.vue
// module id = null
// module chunks = 